/**
 * Domain error raised when a biometric deletion request fails for a reason
 * other than 404 (which is treated as idempotent success).
 *
 * Change: nueva-seccion-de-borrado-perfiles-en-administracion-empleados
 */
export class BiometricDeletionError extends Error {
  constructor(
    public readonly kind: string,
    message: string,
  ) {
    super(message);
    this.name = 'BiometricDeletionError';
  }
}
